/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface GetLinkedRobloxAccountResponseContent
 */
export interface GetLinkedRobloxAccountResponseContent {
    /**
     * 
     * @type {string}
     * @memberof GetLinkedRobloxAccountResponseContent
     */
    robloxUserId: string;
}


/**
 * Check if a given object implements the GetLinkedRobloxAccountResponseContent interface.
 */
export function instanceOfGetLinkedRobloxAccountResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "robloxUserId" in value;
    return isInstance;
}

export function GetLinkedRobloxAccountResponseContentFromJSON(json: any): GetLinkedRobloxAccountResponseContent {
    return GetLinkedRobloxAccountResponseContentFromJSONTyped(json, false);
}

export function GetLinkedRobloxAccountResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLinkedRobloxAccountResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'robloxUserId': json['robloxUserId'],
    };
}

export function GetLinkedRobloxAccountResponseContentToJSON(value?: GetLinkedRobloxAccountResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'robloxUserId': value.robloxUserId,
    };
}

